const MomentConstants = {
    MOMENT_API_FORMAT: "YYYY-MM-DD",
    MOMENT_API_FORMAT_WITH_TIME: "YYYY-MM-DDTHH:mm:ss",
    MOMENT_DATEPICKER_FORMAT: "DD/MM/YYYY"
}

export default MomentConstants;